/** @format */

import {
  REPORT_ORGANIZATION_FAILURE,
  REPORT_ORGANIZATION_REQUEST,
  REPORT_ORGANIZATION_SUCCESS,
} from "./reportOrganizationTypes.js";

const initialState = {
  loading: false,
  response: {},
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REPORT_ORGANIZATION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case REPORT_ORGANIZATION_SUCCESS:
      return {
        loading: false,
        response: action.payload,
        error: "",
      };
    case REPORT_ORGANIZATION_FAILURE:
      return {
        loading: false,
        response: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
